import type { DonationPledge } from '$types/interfaces';
import { Collections, type DonationsPledgesResponse } from '$types/pocketbase';
import { currentUser, pbClient } from '$lib/client/pocketbase';
import { get } from 'svelte/store';

export async function getPledgeData(): Promise<DonationPledge | null> {
  const response = await pbClient
    .collection(Collections.DonationsPledges)
    .getFirstListItem<DonationsPledgesResponse>(`user = "${get(currentUser)?.id}"`)
    .catch(() => null);
  if (!response) return null;
  return {
    amount: response.amount,
    variableSymbol: response.variableSymbol,
    frequency: 'monthly'
  };
}
